// src/pages/customer/useCustomerData.js
import { useState, useCallback } from 'react';
import api from '../../utils/api';

export function useCustomerData(customerId) {
  const [myOrders,    setMyOrders]    = useState([]);
  const [myWishlist,  setMyWishlist]  = useState([]);
  const [myInquiries, setMyInquiries] = useState([]);
  const [stats, setStats] = useState({
    totalOrders:   0,
    pendingOrders: 0,
    totalSpent:    0,
    wishlistCount: 0,
  });
  const [loading, setLoading] = useState(false);
  const [error,   setError]   = useState('');

  const fetchMyOrders = useCallback(async () => {
    if (!customerId) return;
    setLoading(true); setError('');
    try {
      const { data } = await api.get('/api/customer/orders');
      setMyOrders(data);
      const spent = data
        .filter(o => ['delivered', 'completed', 'confirmed'].includes(o.status))
        .reduce((sum, o) => sum + Number(o.amount || 0), 0);
      setStats(prev => ({
        ...prev,
        totalOrders:   data.length,
        pendingOrders: data.filter(o => ['pending', 'confirmed'].includes(o.status)).length,
        totalSpent:    spent,
      }));
    } catch {
      setError('Could not load your orders.');
    } finally { setLoading(false); }
  }, [customerId]);

  const fetchMyWishlist = useCallback(async () => {
    if (!customerId) return;
    setLoading(true); setError('');
    try {
      const { data } = await api.get('/api/customer/wishlist');
      setMyWishlist(data);
      setStats(prev => ({ ...prev, wishlistCount: data.length }));
    } catch {
      setError('Could not load your wishlist.');
    } finally { setLoading(false); }
  }, [customerId]);

  const fetchMyInquiries = useCallback(async () => {
    if (!customerId) return;
    setLoading(true); setError('');
    try {
      const { data } = await api.get('/api/customer/inquiries');
      setMyInquiries(data);
    } catch {
      setError('Could not load inquiries.');
    } finally { setLoading(false); }
  }, [customerId]);

  const removeFromWishlist = async (animalId) => {
    try {
      await api.delete(`/api/customer/wishlist/${animalId}`);
      setMyWishlist(prev => prev.filter(item => item.id !== animalId));
      setStats(prev => ({ ...prev, wishlistCount: prev.wishlistCount - 1 }));
    } catch (err) {
      console.error('removeFromWishlist failed:', err.response?.data || err.message);
      throw err;
    }
  };

  return {
    myOrders, myWishlist, myInquiries, stats, loading, error,
    fetchMyOrders, fetchMyWishlist, fetchMyInquiries,
    removeFromWishlist,
  };
}